import { EnvironmentStatus, SessionEnvironment } from '@restofrit/structures'
import { Decoder } from '@simonbackx/simple-encoding'

import { Session } from './Session'

/**
 * The client-facing half of environment routing. Reads and requests changes
 * via the server — never decides or stores the environment itself. Routing
 * happens entirely server-side (see EnvironmentProxyMiddleware on the
 * backend); this is purely so the app can display which environment its
 * session is actually on (the persistent test banner) and ask the server to
 * change it.
 */

/** Fetches the environment the current session is actually on right now. */
export async function getCurrentEnvironment(): Promise<SessionEnvironment> {
    const response = await Session.shared.authenticatedServer.request({
        method: "GET",
        path: "/session/environment",
        decoder: EnvironmentStatus as Decoder<EnvironmentStatus>,
    })
    return response.data.environment
}

/**
 * Requests a switch. The server decides whether it's allowed (isTester for
 * `test`; always allowed back to `production`) — this can reject.
 * Callers are expected to clear any cached app state and reload afterwards
 * (tokens/data are per-environment), matching the returned environment, not
 * the one that was requested.
 */
export async function setCurrentEnvironment(environment: SessionEnvironment): Promise<SessionEnvironment> {
    const response = await Session.shared.authenticatedServer.request({
        method: "POST",
        path: "/session/environment",
        body: EnvironmentStatus.create({ environment }),
        decoder: EnvironmentStatus as Decoder<EnvironmentStatus>,
    })
    return response.data.environment
}
